export const MISSING_TENANT_OPTION_REASON = 'missing_tenant_option';
